"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { HiXMark } from "react-icons/hi2";
import { useParams } from "next/navigation";
import { ReportDataIssueDialog } from "./report-data-issue-dialog";
interface ImportIssueBannerProps {
  sourceSystem: string | null;
  category: string;
}
function getDismissKey(tenantSlug: string, category: string) {
  return `${tenantSlug}:import-banner:${category}`;
}
export function ImportIssueBanner(t0) {
  const $ = _c(26);
  const {
    sourceSystem,
    category
  } = t0;
  const params = useParams();
  const tenantSlug = params.tenant as string;
  let t1;
  if ($[0] !== category || $[1] !== tenantSlug) {
    t1 = getDismissKey(tenantSlug, category);
    $[0] = category;
    $[1] = tenantSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const dismissKey = t1;
  let t2;
  if ($[3] !== dismissKey) {
    t2 = () => {
      if (typeof window === "undefined") {
        return false;
      }
      return localStorage.getItem(dismissKey) === "1";
    };
    $[3] = dismissKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [dismissed, setDismissed] = useState(t2);
  const [dialogOpen, setDialogOpen] = useState(false);
  if (dismissed) {
    return null;
  }
  let t3;
  if ($[5] !== dismissKey) {
    t3 = () => {
      localStorage.setItem(dismissKey, "1");
      setDismissed(true);
    };
    $[5] = dismissKey;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleDismiss = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="size-1 rounded-full bg-[#C5A37E]" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = sourceSystem ? `Imported from ${sourceSystem}` : "Recently imported";
  let t6;
  if ($[8] !== t5) {
    t6 = <span>{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span> </span>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <button onClick={() => setDialogOpen(true)} className="font-medium text-[#4A5D4E] underline-offset-2 hover:underline">Report an issue</button>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6) {
    t9 = <span className="flex-1 text-body text-[#1B211B]/50">{t6}{t7}·{" "}{t8}</span>;
    $[12] = t6;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <HiXMark className="size-3.5" />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== handleDismiss) {
    t11 = <button onClick={handleDismiss} className="shrink-0 rounded p-0.5 text-[#1B211B]/20 transition-colors hover:text-[#1B211B]/40" aria-label="Dismiss banner">{t10}</button>;
    $[15] = handleDismiss;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t9) {
    t12 = <div className="flex items-center gap-3 border-b border-[#C5A37E]/15 bg-[#FAF6F0] px-4 py-2">{t4}{t9}{t11}</div>;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== category || $[21] !== dialogOpen) {
    t13 = <ReportDataIssueDialog open={dialogOpen} onOpenChange={setDialogOpen} category={category} />;
    $[20] = category;
    $[21] = dialogOpen;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}